import * as React from 'react'

const SvgPhoneCall = (props) => (
  <svg
    width={30}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.5 6.875a4.38 4.38 0 0 1-4.375 4.375V2.5A4.38 4.38 0 0 1 12.5 6.875ZM12.5 23.125A4.38 4.38 0 0 1 8.125 27.5v-8.75a4.38 4.38 0 0 1 4.375 4.375Z'
      fill='#101AA1'
    />
    <path
      opacity={0.35}
      d='M6.25 11.25h1.875l1.875-5L8.125 2.5c-1.562 0-3.018.79-3.87 2.101v.002a19.091 19.091 0 0 0 0 20.797 4.615 4.615 0 0 0 3.87 2.1L10 23.75l-1.875-5H6.25v-7.5ZM21.25 5a7.5 7.5 0 0 0-7.5 7.5c0 1.194.286 2.319.783 3.32l-.754 3.014a.938.938 0 0 0 1.137 1.137l3.014-.753a7.475 7.475 0 0 0 3.32.782 7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5Z'
      fill='#101AA1'
    />
    <path
      d='M23.75 11.25h-5a1.25 1.25 0 1 1 0-2.5h5a1.25 1.25 0 1 1 0 2.5ZM21.25 16.25h-2.5a1.25 1.25 0 1 1 0-2.5h2.5a1.25 1.25 0 1 1 0 2.5Z'
      fill='#101AA1'
    />
  </svg>
)

export default SvgPhoneCall
